import axios from "axios";

const normalizeBaseUrl = (value = "") => value.replace(/\/+$/, "");

export const API_BASE_URL = normalizeBaseUrl(process.env.REACT_APP_BE_URL || "");

export const buildApiUrl = (path = "") => {
  const normalizedPath = String(path).replace(/^\/+/, "");

  if (!API_BASE_URL) {
    return `/${normalizedPath}`;
  }

  return normalizedPath ? `${API_BASE_URL}/${normalizedPath}` : API_BASE_URL;
};

export const requireAccessToken = (accessToken) => {
  if (!accessToken) {
    throw new Error("Token di accesso non disponibile");
  }

  return accessToken;
};

export const getAuthHeaders = (accessToken) => ({
  Authorization: `Bearer ${requireAccessToken(accessToken)}`,
});

const apiClient = (accessToken, path = "") => {
  return axios.create({
    baseURL: buildApiUrl(path),
    headers: getAuthHeaders(accessToken),
    timeout: 10000,
  });
};

export default apiClient;
